$.widget("bluaul.vcInvoke", {
    options: {
        container: { //Information about element vcInvoke calls on
            id: "",
            height: 0,
            width: 0
        },
        getType: function () { return this.name.split("_")[0]; }, //select visual type by prefix of name (first index always exists)
        invokeType: "addVisualContent",
        name: undefined,
        vcgid: moment().format("DDMMYYYYHHmmssSSS"), //set to timestamp on creation with milliseconds
        vcvid: undefined,
        date: moment().format("DD.MM.YYYY HH:mm:ss"), //set to timestamp on creation with formatting
        parameter: {},
        signalParameter: {},
        deviceType: 1,
        debug: false,
        showFullscreen: false,
        showHeaderMenu: false,
        callback: undefined,
        onError: undefined,
        blid: undefined
    },
    _create: function () {
        return true;
    },
    _init: function () {
        try {
          
            var visual = new vcVisual();
         
            /**
             * check if additional settings are set and determine what to do
             */
            if (this.options.showFullscreen) {
                visual.showFullscreen = true;
            }
            if (this.options.showHeaderMenu) {
                visual.showHeaderMenu = true;
            }

            /**
             * set container(called element and root-element of visual) attributes
             * no else needed because of default values in options
             */
            if (this.element.attr("id") !== null) {
                this.options.container.id = this.element.attr("id");
            }
            if (this.element.height() !== null) {
                this.options.container.height = parseInt(this.element.height());
            }
            if (this.element.width() !== null) {
                this.options.container.width = parseInt(this.element.width());
            }

            if (typeof this.options.blid == undefined) { this.options.blid = -1}

            /**
             * insert container with timestamp as vcvid
             */
            this.element.html("").append(
                $("<div>").attr("id", this.options.container.id + "__" + this.options.vcgid)
            );
            /**
             * vcvid has a higher priority and gets looked up first
             * name has a lower priority and gets looked up after the vcvid
             *
             * after both cases theres a switch case statement that determines the function thats to call
             */
          

            if ("vcvid" in this.options) {
                switch (this.options.invokeType) {
                    case "addVisual":
                        visual.addVisual(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );
                        break;
                    case "addVisualBase":

                       
                        visual.addVisualBase(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );
                        break;


                    case "addVisualContent":


                        visual.addVisualContent(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );
                        break;
                    case "addVisualLegend":
                        visual.addVisualLegend(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError
                        );
                        break;
                    case "addVisualHeader":
                        visual.addVisualHeader(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType
                        );
                        break;
                    case "getVisualValidation":
                        visual.getVisualValidation(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType
                        );
                        break;
                    case "addVisualInFrame":
                        visual.addVisualInFrame(
                            this.options.container.id + "__",
                            this.options.vcvid,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.debug
                        );
                        break;
                    default:
                        return false; //return false if false invokeType is given
                }
            } else if ("name" in this.options) {
                switch (this.options.invokeType) {
                    case "addVisual":
                        visual.addVisualByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );
                        break;
                    case "addVisualBase":
                        visual.addVisualBaseByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );
                        break;
                    case "addVisualContent":
                        visual.addVisualContentByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError,
                            this.options.blid
                        );

                        break;
                    case "addVisualLegend":
                        visual.addVisualLegendByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType,
                            this.options.callback,
                            this.options.onError
                        );
                        break;
                    case "addVisualHeader":
                        visual.addVisualHeaderByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType
                        );
                        break;
                    case "getVisualValidation":
                        visual.getVisualValidationByName(
                            this.options.container.id + "__",
                            this.options.name,
                            this.options.vcgid,
                            this.options.date,
                            this.options.container.height,
                            this.options.container.width,
                            JSON.stringify(this.options.parameter),
                            JSON.stringify(this.options.signalParameter),
                            this.options.deviceType
                        );
                        break;
                    default:
                        return false; //return false if false invokeType is given
                }
            } else {
                return false;
            }
        } catch (e) {
            console.error(e);
            return false;
        }
        return true;
    },
    _destroy: function () {
        try {
            this.element
                .removeClass()
                .html("");
        } catch (e) { console.error(e); return false;}
        return true;        
    }
});